"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_TYPE_SUBSCRIPTION_TIER_MAP = exports.FORBIDDEN_SUBSCRIPTIONS_RESPONSES = exports.SUGGESTED_COURSES_ENROLMENTS_FETCH_LIMIT = exports.SUGGESTED_COURSES_DEFAULT_LIMIT = exports.COURSE_QUERY_MAX_TAG_BUCKET_COUNT = exports.DEFAULT_FETCH_ALL_LIMIT = exports.SERVICE_NAME = void 0;
const course_service_types_1 = require("@seneca/course-service-types");
exports.SERVICE_NAME = 'course-service';
exports.DEFAULT_FETCH_ALL_LIMIT = 2000;
exports.COURSE_QUERY_MAX_TAG_BUCKET_COUNT = 60;
exports.SUGGESTED_COURSES_DEFAULT_LIMIT = 50;
exports.SUGGESTED_COURSES_ENROLMENTS_FETCH_LIMIT = 2000;
exports.FORBIDDEN_SUBSCRIPTIONS_RESPONSES = Object.freeze({
    cannotAccessCourse: 'User cannot access course',
    subscriptionInactive: 'Subscription not active',
    noSubscription: 'No subscription found',
    invalidSubscription: 'Subscription not valid'
});
exports.CONTENT_TYPE_SUBSCRIPTION_TIER_MAP = {
    [course_service_types_1.ContentType.standard]: course_service_types_1.COURSE_SUBSCRIPTION_TIERS.free,
    [course_service_types_1.ContentType.hardestQuestions]: course_service_types_1.COURSE_SUBSCRIPTION_TIERS.premium
};
__exportStar(require("./parentNameMaps"), exports);
__exportStar(require("./permissionsGroupNames"), exports);
//# sourceMappingURL=index.js.map